import { useEffect } from 'react';

const BUNDLE = /main\.[A-Za-z0-9]+\.js/;

// Every `intervalMs`, compare the deployed main bundle to the one currently running and reload
// if it changed, so long-lived tabs pick up a new UI build without a manual refresh.
// No-op on the dev server, where the bundle isn't content-hashed (HMR handles updates there).
export function useAppUpdateWatcher(intervalMs = 1 * 60 * 1000) {
  useEffect(() => {
    const running = Array.from(document.scripts)
      .map((s) => s.src.match(BUNDLE)?.[0])
      .find(Boolean);
    if (!running) return;

    const id = window.setInterval(async () => {
      try {
        const res = await fetch(`/index.html?_=${Date.now()}`, { cache: 'no-store' });
        const latest = (await res.text()).match(BUNDLE)?.[0];
        if (latest && latest !== running) window.location.reload();
      } catch {
        // ignore offline / transient failures; retried on the next interval
      }
    }, intervalMs);

    return () => window.clearInterval(id);
  }, [intervalMs]);
}
